import { Box } from '@mui/material'
import React from 'react'
import { Constants } from '../constants'

export const AvatarCollabs = () => {
    return (
        <Box
            sx={{
                p: "5px",
                bgcolor: "primary.main",
                borderRadius: "12px",
                display: "inline-flex",
                position: "relative",
            }}
        >
            {[Constants.customImages.EventAvatar, Constants.customImages.EventAvatar, Constants.customImages.EventAvatar, Constants.customImages.EventAvatar].map((item, index) => (
                <Box
                    key={index}
                    sx={{
                        position: "relative",
                        marginLeft: index === 0 ? 0 : "-15px",
                        display: "inline"
                    }}
                >
                    <img
                        src={item}
                        alt={`Image ${index}`}
                        style={{
                            width: "25px",
                            height: "25px",
                            borderRadius: "50%",
                        }}
                    />
                </Box>
            ))}
        </Box>
    )
}
